module.exports = __webpack_public_path__ + "assets/images/10Box.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/10Box.png
// module id = 1277
// module chunks = 1